import axiosInstance, { getAuthToken } from "@/utils/appsettings";

// UAT 1030imp1 (2026-10-30): separate components each fetched this, per tab, per credit event, and exhausted the API's DB pool; all reads share this one.

export const BILLING_SUMMARY_FRESH_MS = 5000;

type Entry = { promise: Promise<any>; generation: number; settledAt?: number };

const entries = new Map<string, Entry>();
let generation = 0;

/** GET /protected/user_billing_summary, shared by concurrent callers and reused for a few seconds unless credits changed since. */
export function fetchBillingSummary(queryString: string, opts: { token?: string | null; maxAgeMs?: number } = {}): Promise<any> {
  const maxAge = opts.maxAgeMs ?? BILLING_SUMMARY_FRESH_MS;
  const existing = entries.get(queryString);
  if (existing && existing.generation === generation) {
    if (existing.settledAt === undefined || Date.now() - existing.settledAt < maxAge) return existing.promise;
  }
  const token = opts.token ?? getAuthToken();
  const entry: Entry = { generation, promise: Promise.resolve() };
  entry.promise = axiosInstance
    .get(`/protected/user_billing_summary${queryString}`, { headers: { Authorization: `Bearer ${token}` } })
    .then((res) => {
      entry.settledAt = Date.now();
      return res.data;
    })
    .catch((err) => {
      // A failure is never cached, so the next caller retries
      if (entries.get(queryString) === entry) entries.delete(queryString);
      throw err;
    });
  entries.set(queryString, entry);
  return entry.promise;
}

/** Credits or the plan changed: the next read goes to the server, and a request already in flight is not handed out again. */
export function invalidateBillingSummary(): void {
  generation += 1;
}

/** Test helper. */
export function resetBillingSummaryCache(): void {
  entries.clear();
  generation = 0;
}
